module.exports = __webpack_public_path__ + "e98e8496cdfe5286ff117a8e5712c69a.jpg";